import { render, staticRenderFns } from "./commissionSettings.vue?vue&type=template&id=284b87ac&scoped=true"
import script from "./commissionSettings.vue?vue&type=script&lang=js"
export * from "./commissionSettings.vue?vue&type=script&lang=js"
import style0 from "./commissionSettings.vue?vue&type=style&index=0&id=284b87ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b87ac",
  null
  
)

export default component.exports